import {accordion} from "./accordion";

export function popups() {
    $(window).on("load", function () {
        const mainWrap = $("body");

        function closePopup() {
            if ($('body').hasClass('single-menu')) {
                window.location.href = window.origin + "/menu";
            } else {
                $(".popup").removeClass("active").find('.ajax-popup-content').html('');
                mainWrap.removeClass("popup-open");
                let splitURL = window.location.href.split('?');
                if (splitURL.length > 1) {
                    window.history.pushState(null, null, window.location.href.split('?')[0]);
                }
            }
        }

        $(document).on("click", ".popup-link", function (event) {
            event.preventDefault();

            let $this = $(this);
            let $url = $this.attr("href");
            let parseUrl = $url.split('#');
            let $target = '#' + parseUrl[1];

            if ($this.attr('data-ingredient')) {
                let ingredientsPopup = $('#popup-ingredients');

                let data = {
                    'action': 'get_ingredient_info',
                    'post_id': $(this).attr("data-ingredient")
                };

                $.ajax({
                    url: ajaxvars.ajaxurl,
                    data: data,
                    type: 'POST',
                    success: function (response) {
                        if (response) {
                            ingredientsPopup.find('.ajax-popup-content').html(response);
                            setTimeout(() => {
                                $('.ingredients-slider').slick({
                                    slidesToScroll: 1,
                                    slidesToShow: 1,
                                    dots: true
                                });
                            }, 100)
                        }
                    },
                    complete: function () {
                        $($target).addClass("active").fadeIn(300);
                        mainWrap.addClass("popup-open");
                    }
                });

            } else if ($this.attr('data-menu')) {
                let menuPopup = $('#popup-menu');

                let data = {
                    'action': 'get_menu_item_info',
                    'post_id': $(this).attr("data-menu")
                };

                $.ajax({
                    url: ajaxvars.ajaxurl,
                    data: data,
                    type: 'POST',
                    success: function (response) {
                        if (response) {
                            menuPopup.find('.ajax-popup-content').html(response);
                            setTimeout(() => {
                                $('.ingredients-slider').slick({
                                    slidesToScroll: 1,
                                    slidesToShow: 1,
                                    dots: true
                                });
                            }, 100);

                            accordion();
                        }
                    },
                    complete: function () {
                        $($target).addClass("active").fadeIn(300);
                        mainWrap.addClass("popup-open");
                    }
                });
            } else {
                $($target).addClass("active").fadeIn(300);
                mainWrap.addClass("popup-open");
            }


        }).on("click", ".popup-close", function () {
            closePopup.call(this);
        });


        //ingredients-slider
        setTimeout(() => {
            $('.ingredients-slider').slick({
                slidesToScroll: 1,
                slidesToShow: 1,
                dots: true
            });
        }, 100)


        $(".popups").on("click", function (event) {
            if (!$(event.target).closest(".popup-holder").length && !$(event.target).parents('.jcf-select-drop').length) {
                closePopup.call(this);
            }
        });

        //subscribe form
        let $form = $('.subscribe-form form');
        let $resultElement = $('.subscribe-results');

        let email = $('#mce-EMAIL');
        let error_email = email.parent().find('.error');

        let location_select = $('.location-select');
        let location_select_error = location_select.parents('.form-item').find('.error');

        function isValidEmail(email) {
            if (!email || !email.length) {
                return false;

            } else {
                var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                return regex.test(email);
            }
        }

        function check_email($email) {
            if (!isValidEmail($email)) {
                error_email.addClass('visible');
            } else {
                error_email.removeClass('visible');
            }
        }

        function check_location(location_select) {
            if (location_select.find('option:selected').val() == '') {
                console.log('select');
                location_select_error.addClass('visible');
            } else {
                location_select_error.removeClass('visible');
            }
        }

        email.on('input', function () {
            check_email($(this).val());
        });

        location_select.on('change', function () {
            check_location($(this));
        });

        $form.submit(function (e) {
            e.preventDefault();

            $resultElement.html();

            check_email(email.val());
            check_location(location_select);

            if ($(this).find('.error.visible').length === 0) {
                submitSubscribeForm($form, $resultElement);
            }
        });

        function submitSubscribeForm($form, $resultElement) {
            $.ajax({
                type: "GET",
                url: $form.attr("action"),
                data: $form.serialize(),
                cache: false,
                dataType: "jsonp",
                jsonp: "c", // trigger MailChimp to return a JSONP response
                contentType: "application/json; charset=utf-8",
                beforeSend: function () {
                    $form.find('.button').attr('disabled', 'disabled');
                },
                success: function (data) {
                    if (data.result != "success") {
                        var message = data.msg || "Sorry. Unable to subscribe. Please try again later.";
                        if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
                            message = "You're already subscribed. Thank you.";
                        }

                        $resultElement.html(message);
                    } else {
                        $resultElement.hide();

                        $('.subscribe-form form').hide();
                        $('.subscribe-form .success-popup').show();
                    }
                },
                complete: function () {
                    $form.find('.button').removeAttr('disabled');
                }
            });
        }
    });
}




// WEBPACK FOOTER //
// ./assets/js/modules/popups.js